import { useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import NavbarGlobal from 'Components/UI/Molecules/NavBar'
import NewStorage from 'Components/UI/Organisms/Plant/Storages/New'
import WarehouesesTable from 'Components/UI/Organisms/Plant/Storages/Table'
import Template from 'Components/UI/Templates/Common'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'

const WarehousesTemplate = () => {
  const [render, setRender] = useState(false)

  const { state, setOpen, setClose } = SetState()
  const location = getUbicacion() || ''
  const { pathname } = useLocation()
  const BUTTONS = [
    {
      menuIcon: <AddIcon fontSize="small" />,
      menuTitle: 'Nuevo',
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: oemColorButton(pathname, location),
      onClick: setOpen,
    },
  ]

  return (
    <>
      <Template
        navbar={<NavbarGlobal title="Planta" subTitle="Almacenes" buttons={BUTTONS} />}
        table={<WarehouesesTable render={render} setRender={setRender} />}
      />
      {state.suspense && (
        <NewStorage
          open={state.open}
          handleclose={setClose}
          render={render}
          setRender={setRender}
        />
      )}
    </>
  )
}
export default WarehousesTemplate
